import {
  FaInstagram,
  FaLinkedin,
  FaGithub,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";

import { FaXTwitter } from "react-icons/fa6";
import { SiUpwork } from "react-icons/si";

// SERVICES
export const servicesData = [
  {
    title: "Full-Stack Development",
    description:
      "I build secure, scalable, and high-performance web applications with clean architecture, modern technologies, and intuitive user experiences.",
    items: [
      {
        title: "Backend Engineering",
        description:
          "Node.js, NestJS, Express.js, Laravel, REST & GraphQL APIs, WebSockets, Webhooks, Authentication",
      },
      {
        title: "Frontend Development",
        description:
          "React, Next.js, Vue.js, TypeScript, Tailwind CSS, TanStack Query, Responsive UI/UX",
      },
      {
        title: "Database Design",
        description:
          "PostgreSQL, Supabase, MongoDB, Database Optimization, Scalable Data Architecture",
      },
    ],
  },
  {
    title: "AI Integration & Automation",
    description:
      "I build AI-powered applications by integrating Large Language Models (LLMs), intelligent agents, and automation workflows to create smarter, more efficient digital products.",
    items: [
      {
        title: "AI Engineering",
        description:
          "LLMs, LangChain, AI Agents, RAG, Prompt Engineering, AI Workflow Automation",
      },
    ],
  },
  {
    title: "Cloud, DevOps & Optimization",
    description:
      "I deploy, secure, and optimize applications using modern DevOps practices and cloud infrastructure to ensure performance, reliability, and scalability.",
    items: [
      {
        title: "Cloud & Deployment",
        description: "AWS, Docker, Vercel, GitHub Actions, CI/CD Pipelines",
      },
      {
        title: "Performance & Security",
        description:
          "Technical SEO, Performance Optimization, OAuth, JWT, XSS & SQL Injection Protection",
      },
    ],
  },
];

// PROJECTS
export const projects = [
  {
    id: 1,
    name: "Megent",
    description:
      "Landing Website - Policy language and runtime security for AI agents, designed with calm controls and deterministic enforcement.",
    href: "https://megent.dev/",
    image: "/assets/projects/megent.png",
    frameworks: [
      { id: 1, name: "React" },
      { id: 2, name: "Next.js" },
      { id: 3, name: "TypeScript" },
      { id: 4, name: "Tailwind CSS" },
      { id: 5, name: "shadcn ui" },
    ],
  },
  {
    id: 2,
    name: "Ahadoo",
    description:
      "A landing website for a software agency that provides software development and saas products development services",
    href: "https://ahadoo.com/",
    image: "/assets/projects/ahadoo.png",
    frameworks: [
      { id: 1, name: "React" },
      { id: 2, name: "Tailwind CSS" },
    ],
  },
  {
    id: 3,
    name: "Firabyte",
    description:
      "A modern tech blog platform built with Next.js, featuring MDX posts, AI-powered search, comments, newsletters, and full-stack authentication.",
    href: "https://firabyte.tech/",
    image: "/assets/projects/firabyte.png",
    frameworks: [
      { id: 1, name: "Next.js" },
      { id: 2, name: "TypeScript" },
      { id: 3, name: "Tailwind CSS" },
      { id: 4, name: "shadcn ui" },
      { id: 5, name: "Prisma" },
      { id: 6, name: "PostgreSQL" },
      { id: 7, name: "Cloudinary" },
      { id: 8, name: "Resend" },
    ],
  },
  {
    id: 4,
    name: "AfriHakim - AI Powered Healthcare Ecosystem",
    description:
      "A landing website for a startup called AfriHakim that provides AI powered healthcare ecosystem",
    href: "https://afrihakim.com",
    image: "/assets/projects/afrihakim.png",
    frameworks: [
      { id: 1, name: "Next.js" },
      { id: 2, name: "TypeScript" },
      { id: 3, name: "Tailwind CSS" },
    ],
  },
  {
    id: 5,
    name: "OmniMed",
    description: "AI powered medical assistant with voice agent",
    href: "https://omnimed-phi.vercel.app/",
    image: "/assets/projects/omnimed.png",
    frameworks: [
      { id: 1, name: "Next.js" },
      { id: 2, name: "TypeScript" },
      { id: 3, name: "Drizzle ORM" },
      { id: 4, name: "Neon DB" },
      { id: 5, name: "shadcn ui" },
      { id: 6, name: "LLAMA" },
    ],
  },
  {
    id: 6,
    name: "Love & Letters",
    description:
      "Blogging full-stack website with role-based access (Admin, Author, Reader)",
    href: "https://lovenletters.blog",
    image: "/assets/projects/lovenletters.png",
    frameworks: [
      { id: 1, name: "React" },
      { id: 2, name: "TypeScript" },
      { id: 3, name: "Tailwind CSS" },
      { id: 4, name: "Node.js" },
      { id: 5, name: "Postgres" },
      { id: 6, name: "Drizzle" },
    ],
  },
  {
    id: 7,
    name: "BY Dental Clinic",
    description: "Landing Page UI Design for a dental clinic",
    href: "#",
    image: "/assets/projects/bydental.png",
    frameworks: [
      { id: 1, name: "Figma" },
      { id: 2, name: "Adobe Illustrator" },
    ],
  },
];

// SOCIALS
export const socials = [
  {
    name: "Email",
    href: "mailto:contact@firatolin.tech",
    icon: FaEnvelope,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/firatolin.tefera?igsh=M2Rod3FjbDBoYzdm",
    icon: FaInstagram,
  },
  {
    name: "X",
    href: "https://x.com/firatolin_",
    icon: FaXTwitter,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/firatol-esayas-tefera",
    icon: FaLinkedin,
  },
  {
    name: "GitHub",
    href: "https://github.com/firatolin",
    icon: FaGithub,
  },
  {
    name: "UpWork - Freelancing",
    href: "https://www.upwork.com/freelancers/~013702dbb39e143318",
    icon: SiUpwork,
  },
  {
    name: "Firabyte",
    href: "https://firabyte.tech/",
    icon: FaGlobe, // or use a custom blog icon if available
  },
];
